import { configuration as productionConfiguration } from './configurations/production';
import {
  EnvironmentConfigurationHandler,
  environmentConfigurationMatchers,
} from '@gls/platform-ui';

export type ApplicationEnvironmentConfiguration = {
  production: boolean;
  redirectUri: string;
  postLogoutUrl: string;
  baseUrl: string;
  authorities: {
    signUpSignInB2C: {
      authority: string;
      clientId: string;
      tenantId: string;
    };
    signUpSignInAD: {
      authority: string;
      clientId: string;
      tenantId: string;
    };
  };
  authorityDomain: string;
  apiProductNames: {
    CUSTOMS_CONSIGNMENTS_V3: string;
  };
};

export const environment2 =
  new EnvironmentConfigurationHandler<ApplicationEnvironmentConfiguration>();

export async function initApplicationEnvironmentConfiguration() {
  await environment2.init(
    document.location.hostname,
    [
      {
        matches: environmentConfigurationMatchers.docker,
        configuration: () =>
          import('./configurations/docker').then(
            ({ configuration }) => configuration,
          ),
      },
      {
        matches: environmentConfigurationMatchers.local,
        configuration: () =>
          import('./configurations/local').then(({ configuration }) => {
            return configuration;
          }),
      },
      {
        // development: um.dev.xbp.gls-group.net
        matches: [/um\.dev\.xbp\.gls-group\.net/],
        configuration: () =>
          import('./configurations/development').then(({ configuration }) => {
            return configuration;
          }),
      },
      {
        // stage: um.test.xbp.gls-group.net
        matches: [/um\.test\.xbp\.gls-group\.net/],
        configuration: () =>
          import('./configurations/stage').then(({ configuration }) => {
            return configuration;
          }),
      },
    ],
    // production: um.xbp.gls-group.net
    productionConfiguration,
  );
}

// environment.ts

export const getCustomsConsignmentsV3Name = (): string => {
  const hostname = document.location.hostname;

  console.log('hostname:', document.location.hostname);
  
  return hostname === 'um.xbp.gls-group.net'
    ? 'customs-consignments-prod-v3'
    : 'customs-consignments-v3';
};